export const jobLocales = {
  action: "Action",
  address: "Address",
  addEditJob: {
    comments: "Comments:",
    createJobSuccessText: "Your Job has been created!",
    createJobSuccessTitle: "Thank you for filling out our form.",
    contractShiftTimeText:
      "* Shift time indicates the arrival time of dental professionals",
    dentalPositionRequested: "* Dental position requested",
    editJobText: "Thank you for editing this job.",
    editJobSuccessText: " Your Job has been edited!",
    editJobSuccessTitle: "Thank you for editing out our form",
    editedBadge: "Edited",
    endTime: "End Time:",
    exitFromTitle: "Are you sure you want to exit?",
    invalidTimeError: "The end time should be greater than the start time",
    jobCancelTitle: "You are about to cancel the job for the role of ",
    noDateSelected: "No date(s) selected.",
    noDateSelectedError: "Please select a date and time",
    pleaseEnterStartTime: "Please enter start time",
    pleaseEnterEndTime: "Please enter end time",
    onBehalfOf: " on behalf of",
    multiDay: "Multi Day",
    officeSelected: {
      action: "Action",
      city: "City",
      nameOfOffice: "Name of office",
      officeId: "Office ID",
      state: "State",
      zip: "Zip",
    },
    payRangeLabel: "What is the expected pay range for this position? ",
    expectedDailyPay: "What is the expected daily pay range for this position?",
    expectedHourlyPay: "Client Expected Pay Range",
    expectedPayRate: "What is the expected daily pay rate for this position?",
    payrangeProfessionals:
      "* Pay range above is reflective of direct pay range, not your all-inclusive bill rate.",
    reasonForCancel: "Reason for Cancellation",
    otherReason: "Other Reason",
    role: " Role ?",
    selectCancelDaysText: "Select the date(s) to cancel",
    selecteDateTime: "Select Date(s) and Time",
    selectedDateTime: "Date(s) and time",
    selectedDateTimeFor: "Selected date(s) and time - ",
    singleDay: "Single Day",
    startTime: "Start Time:",
    shiftBlockTitle: "Shift",
    lunchBlockTitle: "Lunch break",
    lunchBreakStart: "Lunch start",
    lunchBreakEnd: "Lunch end",
    lunchEndAfterLunchStart: "Lunch end must be after lunch start.",
    lunchMustBeWithinShift:
      "Lunch break must start and end within the shift time",
    lunchIncomplete: "Enter both lunch start and end, or clear both.",
    clearLunchBreak: "Clear lunch break",
    selectAllDates: "Select all dates",
    removeScheduleDate: "Remove date",
    suggestedSkills: "Suggested skills based on requested position",
    viewJobList: "View Job List",
    workingHoursNotSet: "Working hours are not set for the selected office.",
    nonWorkingDaysSelectedInfo:
      "Some selected dates are marked as non-working. You can continue by adding shift hours here, or go to the Set Working Hours page to update the default working schedule. These days will not automatically follow the standard working hours.",
    nonWorkingDaysSelectedError:
      "One or more selected dates fall on a non-working day. Add shift hours for those dates or remove them from your selection.",
    setWorkingHours: "Set Working Hours",
    needHelp: "Need help ?",
    selectedDatesCount: "Selected dates",
    expandTable: "Expand",
    collapseTable: "Collapse",
    setTime: "Set Time",
    shiftStartMustBeBeforeEnd: "Shift start must be before shift end",
    lunchStartMustBeBeforeEnd: "Lunch start must be before lunch end",
    tourPickDatesTitle: "Pick your dates",
    tourPickDatesDescSingle:
      "Click a future date on the calendar to select it. Selecting another date replaces the current selection.",
    tourPickDatesDescMulti:
      "Click future dates on the calendar to add them to your schedule. Click a selected date again to remove it.",
    tourBulkTimesTitle: "Set shift times in bulk",
    tourBulkTimesDesc:
      "Enter shift start and end times, select the rows using the checkboxes, then click Set Time to apply those hours to each selected date.",
    tourTableTitle: "Review your schedule",
    tourTableDescSingle:
      "Enter or edit shift start and end times for the selected date. Use the trash icon to remove it.",
    tourTableDescMulti:
      "Each selected date appears here. Edit shift times in any row, use the checkboxes for bulk actions, or delete a date with the trash icon.",
    tourExpandTitle: "Expand the table",
    tourExpandDesc:
      "Click Expand to hide the calendar and give the table more room when reviewing many dates.",
    tourValidateTitle: "Check each row",
    tourValidateDesc:
      "A checkmark means the row is complete. A warning icon means shift start or end time still needs attention. Non-working days need shift hours before you can confirm.",
    tourConfirmTitle: "Save your schedule",
    tourConfirmDesc:
      "When every row is complete, click Confirm to save the selected dates and shift times.",
    unsavedChangesInfo:
      "Rows marked Edited have unsaved changes. Click Update to apply them.",
    dateTimeUnsavedChangesInfo:
      "Highlighted rows have unsaved changes. Click Confirm to apply them.",
    saving: "Saving...",
    save: "Save",
    dentalPosition: "Dental Position",
    expectedStartDate: "Expected start date",
    selectStartDate: "Select start date",
    professionalPayRange: "DDS Push Out Pay Range",
    selectDueDate: "Select due date",
    skillsRequired: "Skills Required",
    actionsToBeCompleted: "Actions to be completed",
    statusCompleted: "Completed",
    statusActionRequired: "Action Required",
    apContactWarnMsgJob:
      "Ap contact details have not been added. Please complete the Ap contact information to proceed the job creation",
    parentApContactWarnMsgJob:
      "Ap contact details of parent office have not been added. Please complete the Ap contact information of parent office to proceed the job creation",
    mixedModelJobWarnMsg:
      "Please add an AP contact to the parent office or your office before creating a new job.",
    apContactWarnMsgAssignProfessional:
      "AP contact details have not been added. Please complete the Ap contact information to assign professionals to the job",
    parentApContactWarnMsgAssignProfessional:
      "Ap contact details of parent office have not been added. Please complete the Ap contact information of parent office to assign professionals to the job",
    mixedModelAssignProfessionalWarnMsg:
      "Please add an AP contact to the parent office or your office before assigning professionals to the job.",
    unsignedAchPaymentMethodWarnMsgAssignProfessional:
      "The office must complete the signing process or upload the signed contract before professionals can be assigned to this job.",
    goToAgreements: "Go to Agreements",
  },
  applicantStatus: "Applicant Status",
  applicantsSchedule: "Applicants & Schedule",
  applicationDetails: "Applicants Details",
  applyBefore: "Apply before",
  areYouSure: "Are you sure you want to ",
  assignApplicant: "Professional assigned successfully",
  assignApplicantError:
    "Can't assign professional. Please check the data you have given.",
  assignConfirmation: "You are about to assign the professional to job",
  assignProfessional: "Assign Professional",
  assignedTo: "assigned to",
  billableHours: "Billable Hours",
  billRate: "Bill rate",
  billRateTransparency: "Bill rate (Without addon charges)",
  billRateDetails: "BILL RATE DETAILS",
  billRatePerHour: "Bill rate per hour",
  billRatePerDay: "Bill rate per day",
  currentBillRate: "Current Bill Rate",
  hourlyBillRate: "Hourly Bill Rate",
  break: "Break/Lunch",
  breakTime: "Break/Lunch Time",
  buttonName: {
    assign: "Assign",
    back: "Back",
    cancel: "Cancel",
    confirm: "Confirm",
    shortlist: "Shortlist",
    submit: "Submit",
  },
  by: "by",
  cancel: "Cancel",
  cancelled: "Cancelled",
  cancelledBy: "cancelled by",
  cancelledByOffice: "Cancelled by office",
  cancelledByProfessional: "Cancelled by professional",
  cancelNotApplicable: "Cancellation of this job is not possible",
  clientId: "Client ID",
  clearAll: "Clear All",
  city: "City",
  completed: "# completed",
  confirmUnassignMessage: "Are you sure you want to unassign this job?",
  contractJobAssigned:
    "{proUser} assigned to the job against the date {date} by dds user {doneBy}, {doneById}",
  contractJobCancelled:
    'Job against the date {date} cancelled by dds user {doneBy},{doneById} on behalf of {type} with reason: "{reason}"',
  current: "CURRENT",
  autoCancelled:
    'Job against the date {date} has been auto cancelled due to reason: "{reason}"',
  contractJobOfficeCancelled:
    "Job against the date {date} cancelled by {doneBy}",
  contractJobCreated: "The job has been created by {doneBy}",
  contractJobEdited: "The job has been edited by {doneBy}",
  contractJobRejected: "The job has been rejected by {doneBy}",
  contractJobPublished: "The job has been published by {doneBy}",
  contractJobUnAssigned:
    "{proUser} is un-assigned to the job against the date {date} by dds user {doneBy}, {doneById}",
  createdBy: "created by",
  createJob: "Create Job",
  deactivated: "Deactivated",
  directJobAssigned:
    "{proUser} assigned to the job by dds user {doneBy},{doneById}",
  directJobCancelled:
    'Job against the date {date} cancelled by dds user {doneBy},{doneById} on behalf of {type} with reason: "{reason}"',
  directJobOfficeCancelled: "Job against the date {date} cancelled by {doneBy}",
  directJobCreated: "The job has been created by {doneBy}",
  directJobEdited: "The job has been edited by {doneBy}",
  directJobPublished: "The job has been published by {doneBy}",
  directJobUnAssigned:
    "{proUser} is un-assigned to the job by dds user {doneBy},{doneById}",
  error: {
    billRateRequired: "Please enter a valid bill rate amount.",
    billRateValid: "The bill rate must be higher than the pay rate.",
    maxPayRateRequired: "Pease enter valid starting pay rate value",
    maxPayRateValid:
      "The current level's staring pay rate must be higher than the previous level's ending pay rate.",
    maxBillRateValid:
      "The current level's bill rate must be higher than the previous level's bill rate.",
    minBillRateValid:
      "The current level's bill rate must be lower than the next level's bill rate.",
    minPayRateRequired: "Pease enter valid ending pay rate value",
    minPayRateValid:
      "The current level's ending pay rate must be lower than the next level's starting pay rate.",
    rateValid: "The ending pay rate must be higher than the starting pay rate.",
  },

  dailyBillRate: "Daily Bill Rate",
  dailyPayRate: "Daily Pay Rate",
  date: "Date",
  details: "Details",
  directAssigned: "Direct job is assigned",
  deleted: "Deleted",
  documentErrorMessage:
    "Please select an option before proceeding. You must choose either MSA1 or MSA2.",
  editAssignment: "Edit Assignment",
  editJob: "Edit Job",
  editJobTime: "Edit Job Time",
  editedBy: "edited by",
  email: "Email",
  endTime: "End Time",
  errors: {
    fieldEmpty: "This field cannot be empty. Please enter/change a value.",
    timeConflict: "Time slot conflicts with existing allocation.",
    timeValidate: "Start time cannot be greater than end time.",
  },
  expenses: {
    attachments: "Attachments",
    cancel: "Cancel",
    combinedSizeInfo: "Combined file size should not exceed 10 MB",
    details: "Details",
    expense: "Expense",
    expenseAdded: "Expense successfully added",
    expenses: "Expenses",
    expenseValue: "Expense Value",
    fileRequired: "Please select a file to upload",
    lodging: "Lodging",
    maxExpenseError: "You can not upload more than 10 MB",
    mb: "MB",
    other: "Other",
    remarks: "Remarks",
    save: "Save",
    submit: "Submit",
    total: "Total",
    travel: "Travel",
    uploadDocument: "UPLOAD DOCUMENT",
    uploadedSize: "Uploaded Size",
    value: "Value",
    valueMustBeGreater: "Value must be greater than 0",
    valueMustBeLess: "Value must be less than 100000",
    valueRequired: "Please enter a value",
  },
  findProfessionals: "Find Professionals",
  findProfessionalRange: "Find professionals with in the range",
  findProfessionalsPlaceholder: "Find professionals within the range",
  filled: "Filled",
  form: "From",
  forTheDate: " for the date: ",
  from: "from",
  fulfill: "fulfill",
  fulfillError: "Job not fulfilled",
  fulfillSuccess: "Job successfully fulfilled",
  hourlyPayRate: "Hourly pay rate",
  hourlyRate: "Hourly Pay Rate",
  hourlyBill: "Hourly Bill Rate",
  hoursSpend: "Hours Spend",
  hrs: "Hrs",
  id: "ID",
  idHeader: "ID",
  initialMessageToDisplayInTheTable:
    "Please select the required filter values to continue.",
  invalidDescriptionValues: "Invalid description values",
  jobDetails: "Job Details",
  job: "Job",
  jobs: "Jobs",
  selected: "selected",
  jobForTheDate: "Job for the date",
  jobId: "Job ID",
  jobHeaderId: "ID : ",
  jobHistory: "Job History",
  jobIsFulfilled: "This date is filled",
  jobOverview: "Job overview",
  jobType: "Job Type",
  jobWasCreatedBy: "Job created by",
  jobWasPublishedBy: "Job published by",
  joinDate: "Expected Joining Date",
  logs: "Logs",
  markAsFulfilled: "Mark as filled",
  mnts: "Mnts",
  mobile: "Mobile",
  name: "Name",
  noOfAssign: "# of Assign",
  nameOfOffice: "Name of office",
  nameOfProfessional: "Name of Professional",
  onPayRate: "On Pay Rate",
  onShiftRate: "On Shift Time",
  office: "Office",
  officeId: "Office ID",
  payRange: "Expected Pay range (Rate / hr)",
  payRangeDay: "Expected Pay range (Rate / day)",
  payRangeError: "Pay range should be in between ",
  payRate: "Pay Rate",
  payrollPayRate: "Expected Pay Rate (Rate / hr)",
  payRateHour: "Pay rate hours",
  payRateHourly: "Hourly Pay Rate",
  payRatePerHour: "Pay rate per hour",
  payRatePerDay: "Pay rate per day",
  payScale: "Payscale (Rate/hr)",
  payScaleDay: "Payscale (Rate/Day)",
  photo: "Photo",
  photoText: "User Profile Image",
  placementType: "Placement type",
  profile: "Profile",
  profitMargin: "Profit Margin",
  professionalName: "Name of Professional",
  professional: "Professional Name",
  professionalNotShortListErrorMessage: "Professional not shortlisted",
  professionalShortlistSuccessMessage: "Professional shortlisted successfully",
  publishedBy: "published by",
  reAssign: "REASSIGNED",
  recruiter: "Recruiter",
  role: "Role",
  searchFilterLoadingInTheTable: "Loading...",
  selectDate: "Select date",
  serviceType: "Service Type",
  shift: "the shift",
  shiftTimeChanged:
    "The shift time of {proUser} was changed by {doneBy}, {doneById}. The new shift time is {assignedStartTime} - {assignedEndTime}, and the job is scheduled for {date}.",
  skills: "Skills",
  otherSkills: "Other Skills",
  startTime: "Start time",
  status: "Status",
  theJob: " the job",
  time: "Time",
  timeFormat: {
    am: "AM",
    pm: "PM",
  },
  timeLabel: "Timing",
  timesheet: "Timesheet",
  timesheetStatus: {
    approveHeader: "Approve Timesheet",
    approveMessage:
      "Are you sure you want to approve timesheet(s) of {name} dated {date}?",
    approveSuccess: "Timesheet approved successfully",
    rejectHeader: "Reject Timesheet",
    reasonRequired: "The reject reason is required",
    rejectSuccess: "Timesheet rejected successfully",
    reasonLabel: "Reason(s) for Rejection *",
    rejectMessage:
      "Are you sure you want to reject timesheet(s) of {name} dated {date}?",
  },
  to: "To",
  toDate: "to",
  totalBillRate: "Total Bill Rate",
  totalPayRate: "Total Pay Rate",
  type: "Type",
  validationForDateSelection: "Please select the date",
  unassignApplicantMessage: "Professional unassigned successfully",
  UnassignApplicantErrorMessage: "Professional not  unassigned successfully",
  unassigned: "Unassigned",
  unassignedBy: "unassigned by",
  unassignedFrom: "unassigned from",
  unFullFill: "un fulfill",
  unFulfillSuccess: "Job successfully un fulfilled",
  viewBillRate: "View bill rate details",
  workingHours: "Working hours",
  youAreAboutTo: "You are about to ",
  zip: "ZIP",
  workingDays: {
    days: {
      friday: "Friday",
      monday: "Monday",
      saturday: "Saturday",
      sunday: "Sunday",
      thursday: "Thursday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
    },
  },
  pleaseEnterJobOverview: "Please enter job overview",
  update: "Update",
  multiDayCancelWarnMsg: "Cannot cancel a job which is past dated",
  officeProfileDeactivated: "Office profile deactivated",
  officeProfileDeleted: "Office profile deleted",
  officeProfileDisabled: "Office profile disabled",
  close: "Close",
  emailId: "Email ID",
  jobCreatedBy: "Job Created By",
  NA: "NA",
  createdByLabel: "Created by",
  findProspect: "Find Prospects",
  state: "State",
  nameOfProspect: "Name of Prospect",
  range: "Range",
  withinRange: "Within mile radius",
  totalBill: "Total Bill",
  totalPay: "Total Pay",
  billable: "Billable",
  payable: "Payable",
  billablePerHour: "Billable per hour",
  payablePerHour: "Payable per hour",
  timesheetEditAfterApproval:
    "The timesheet approved has been edited by {doneBy}, {doneById}",
  timesheetEdited: "The timesheet has been edited by {doneBy}, {doneById}",
  timesheetAdded: "The timesheet has been added by {doneBy}, {doneById}",
  billAmount: "Bill Amount",
  hourRate: "Hourly Rate",
  billAmountExpenseNotAdded: "Bill Amount (Expense is not included)",
  timesheetApproved: "The timesheet has been approved by {doneBy}, {doneById}",
  timesheetRejected: "The timesheet has been rejected by {doneBy}, {doneById}",
  recruiterAssignment:
    "New assignment : Assigned to {assignedTo} by {doneBy}, {doneById}",
  recruiterUnAssignment:
    "Unassignment : {assignedTo} was unassigned by {doneBy}, {doneById}",
  assign: "Assign",
  assignAlertMsg:
    "Please note that the recruiters shown below are based on the permissions set in role management module.",
  assignModalSubTitle:
    "Please select the user to which jobs are to be assigned",
  assignJob: "Assign job",
  recruiters: "Recruiters",
  myAssignments: "My Assignments",
  nameOfRecruiter: "Name of Recruiter",
  noOfJobs: "Number of Jobs",
  dayAssigned: "Days Assigned",
  daysFilled: "Days Filled",
  daysUnfilled: "Days Unfilled",
  daysCancelled: "Days Cancelled",
  noOfAssignments: "Number of Assignments",
  viewJob: "View Job",
  jobID: "Job ID",
  jobRole: "Job Role",
  officeName: "Office Name",
  totalDays: "Total Days",
  daysToFill: "Days to Fill",
  days2Fill: "Days 2 Fill",
  recruiterAssignedSuccessfully: "Recruiter Assigned Successfully",
  noRecruitersFound: "No Recruiters Found",
  assignJobs: "Assign Job(s)",
  assignments: "Assignments",
  back: "Back",
  viewDetails: "View Details",
  masterList: "Master List",
  notes: "Notes",
  noOfDaysCancelled: "Number of days cancelled",
  cancelledDate: "Cancelled Date(s)",
  cancellationInitiatedDate: "Cancellation initiated date",
  officeJobCancellation: "Office Job Cancellation",
  professionalJobCancellation: "Professional Job Cancellation",
  cancelledByName: "Cancelled By",
  unAssign: "UNASSIGNED",
  unfilled: "Unfilled",
  clientExpectedPayRange: "Client Expected Pay Range (Rate/hr)",
  ddsPushOutPayScale: "DDS Push Out Pay Range (Rate/hr)",
  autoPublishedLog: "The job has been autopublished",
  publishedWithPayRangeLog:
    "The job has been published with a pay range by {doneBy}",
  placementSupportFee: "Placement Support Fee",
  ddsServiceFee: "DDS Service Fee",
  hourlyEscalation: "Hourly Escalation (Over 8 hours)",
};
